export default __webpack_public_path__ + "static/notificare-logo-950fccf8b0de143398526d22842421e2.svg";